import { DownloadOutlined } from '@ant-design/icons'
import { Button, message } from 'antd'
import { FC } from 'react'
import downloadFileByBlob from '../../../helpers/download-file-by-blob'
import useErrorModal from '../../../hooks/api/use-error-modal'
import { useLazyDownloadUploadedFileQuery } from '../../../store/api/upload-api'
import UploadedFile from '../../../types/api/uploaded-file'

interface DownloadHonestSignsCodesFileProps {
    files?: UploadedFile[]
}

const DownloadHonestSignsCodesFile: FC<DownloadHonestSignsCodesFileProps> = ({ files }) => {
    const [downloadUploadedFile, downloadState] = useLazyDownloadUploadedFileQuery()

    useErrorModal(downloadState, 'Ошибка скачивания базы кодов')

    const hasFiles = Boolean(files?.length)

    const onClick = async () => {
        if (!files?.length) {
            message.info('База кодов ещё не загружена')
            return
        }

        for (const file of files) {
            const downloadRes = await downloadUploadedFile(file.url)
            if ('error' in downloadRes && downloadRes.error) return
            if (!downloadRes.data) {
                message.error(`Не удалось скачать «${file.name}»`)
                return
            }
            downloadFileByBlob(downloadRes.data, file.name)
        }
    }

    return (
        <Button
            size="small"
            icon={<DownloadOutlined />}
            title="Скачать базу кодов"
            onClick={onClick}
            disabled={!hasFiles}
            loading={downloadState.isLoading || downloadState.isFetching}
        >
            Скачать базу кодов
        </Button>
    )
}

export default DownloadHonestSignsCodesFile
